import { create } from 'zustand';
import { ApiUtils, DownloadAttachmentRequest, MessagesApi, RequestStrategyEnum } from '@shared/api';
import { FileUtils } from '@shared';

interface IDownloadMessageAttachmentStore {
  loading: boolean;
  error: string | null;
  downloadAttachment: (request: DownloadAttachmentRequest, signal?: AbortSignal) => Promise<void>;
  clear: () => void;
}

export const useDownloadMessageAttachmentStore = create<IDownloadMessageAttachmentStore>((set) => ({
  loading: false,
  error: null,

  downloadAttachment: ApiUtils.wrapperApi(async (request: DownloadAttachmentRequest, signal?: AbortSignal) => {
    try {
      set({ loading: true, error: null });
      const result = await MessagesApi.downloadAttachment(request, signal);
      FileUtils.downloadFile(result.data, result.filename);
      set({ loading: false });
    } catch (error) {
      set({ error: (error as Error).message, loading: false });
    }
  }, RequestStrategyEnum.Debounce),

  clear: () => set({ loading: false, error: null }),
}));
